import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Badge,
  Card,
  Form,
  InputGroup,
  ProgressBar,
  Table,
} from "react-bootstrap";
import { useParams } from "react-router";
import UseToggle from "../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import { BsCheck2All, BsClock, BsEye, BsFileText } from "react-icons/bs";
import InvestigatorSignoff from "./InvestigatorSignoff";
import { studySubjectPrincipleInvestigatorServices } from "../../../APIServices/studySubjectPrincipleInvestigatorServices";
import BulkInvestigatorSignoff from "./BulkInvestigatorSignoff";
import { FaXmark } from "react-icons/fa6";
import Pagination from "../../Pagination";

const InvestigatorSignatureTableData = ({ tableRef, onMouseDown }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSiteIds, setSelectedSiteIds] = useState([]);
  const toggles = UseToggle();
  const [type, setType] = useState("all");
  let { studyId } = useParams();
  const [stats, setStats] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [taskCount, setTaskCount] = useState(0);
  const [taskData, setTaskData] = useState("");
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleSelect = (row) => {
    const { _id, siteId } = row;

    if (selectedIds.includes(_id)) {
      setSelectedIds((prev) => prev.filter((id) => id !== _id));
      setSelectedSiteIds((prev) => prev.filter((id) => id !== siteId));
    } else {
      setSelectedIds((prev) => [...prev, _id]);
      setSelectedSiteIds((prev) => [...new Set([...prev, siteId])]);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(taskList.map((item) => item._id));

      setSelectedSiteIds([
        ...new Set(taskList.map((item) => item.siteId)),
      ]);
    } else {
      setSelectedIds([]);
      setSelectedSiteIds([]);
    }
  };

  const statsSubjectPrincipleInvestigator = async () => {
    setLoader(true)
    let data = await studySubjectPrincipleInvestigatorServices.statsSubjectPrincipleInvestigator(studyId, StudyMode)
    setLoader(false)
    setStats(data?.data || "")
  }

  const overviewCards = [
    {
      title: "Total task",
      value: stats?.totalTask,
      subtitle: "Subject ready for sign",
      icon: <BsFileText className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Pending Sign",
      value: stats?.pendingTask,
      subtitle: "Awaiting sign completion",
      icon: <BsClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Signed",
      value: stats?.completedTask,
      subtitle: "Signature successfull action",
      icon: <BsCheck2All className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Failed",
      value: (stats?.totalTask - (stats?.pendingTask + stats?.completedTask)),
      subtitle: "Require corrective action",
      icon: <FaXmark className="bg-white text-danger shadow-sm" />,
    },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(taskCount / itemsPerPage);

  const getSubjectPrincipleInvestigator = async () => {
    setLoading(true)
    let data = await studySubjectPrincipleInvestigatorServices.getSubjectPrincipleInvestigator(studyId, type, StudyMode, pageNumber, itemsPerPage)
    setLoading(false)
    setTaskList(data?.data || [])
    setTaskCount(data?.count || 0);
  }

  useEffect(() => {
    getSubjectPrincipleInvestigator();
  }, [pageNumber, itemsPerPage, studyId, type]);

  useEffect(() => {
    statsSubjectPrincipleInvestigator();
  }, [studyId]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 145px)" }}
      >
        <>
          <div className="p-2 chart__overview hstack justify-content-between gap-3">
            {overviewCards?.map((item, index) => (
              <div key={index} className="h-100 w-100">
                <Card className="app-card bg-light border">
                  <Card.Body>
                    <div className="d-flex gap-3">
                      <div className="study_icopn">{item.icon}</div>
                      <div>
                        <Card.Title style={{ fontSize: 16 }}>
                          {item.title}
                        </Card.Title>
                        <Card.Text className="m-0">
                          {item.value || "0"}
                        </Card.Text>
                        <Card.Text style={{ fontSize: 11 }}>
                          {item.subtitle}
                        </Card.Text>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
          <div
            className="justify-content-between toolbar border-bottom border-top hstack p-1"
            style={{ height: 36 }}
          >
            <InputGroup className="w-auto">
              <button
                onClick={() => setType("all")}
                className={`updateProfile ${type === "all" ? "activee" : ""}`}
              >
                All
              </button>
              <button
                onClick={() => setType("pending")}
                className={`updateProfile ${type === "pending" ? "activee" : ""}`}
              >
                Pending
              </button>
              <button
                onClick={() => setType("signed")}
                className={`updateProfile ${type === "signed" ? "activee" : ""}`}
              >
                Signed
              </button>
              <button
                onClick={() => setType("failed")}
                className={`updateProfile ${type === "failed" ? "activee" : ""}`}
              >
                Failed
              </button>
            </InputGroup>
            {(type === "pending" && !StudyMode?.startsWith("SDV")) &&
              <button disabled={selectedIds?.length === 0} onClick={() => toggles?.setToggle1()} className={`updateProfile`}>
                Review
              </button>
            }
          </div>
          {loading ? (
            <PageLoader />
          ) : taskList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Task list not found!."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    {(type === "pending" && !StudyMode?.startsWith("SDV")) ?
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        <Form.Check
                          checked={
                            taskList?.length > 0 &&
                            selectedIds.length === taskList.length
                          }
                          onChange={handleSelectAll}
                        />
                      </th>
                      :
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                    }

                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Id</th>

                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Id</th>

                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Assign By</th>

                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Assigned Date | Time</th>

                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Assign To</th>

                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Sign Type</th>

                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Status</th>

                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Signed DT</th>

                    <th className="text-center" onMouseDown={(e) => onMouseDown(e, 9)}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {taskList?.map((item, index) => (
                    <tr key={index}>
                      {(type === "pending" && !StudyMode?.startsWith("SDV")) ?
                        <td className="text-center">
                          <Form.Check
                            checked={selectedIds.includes(item._id)}
                            onChange={() => handleSelect(item)}
                          />
                        </td>
                        :
                        <td className="text-center">{index + 1 + startIndex}</td>
                      }
                      <td>{item?.siteName}</td>
                      <td>{item?.subjectName}</td>
                      <td>{item?.assignedByName}</td>
                      <td>{item?.assignedDT}</td>
                      <td>{item?.assignedToName}</td>
                      <td>{item?.type === "statement" ? "First Sign" : "Correction Sign"}</td>
                      <td className={`text-capitalize ${item?.status === "pending" ? "text-warning" : item?.status === "completed" ? "text-success" : "text-danger"}`}>{item?.status}</td>
                      <td>{item?.completedDT}</td>
                      <td className="text-center">
                        <button
                          disabled={item?.status !== "pending"}
                          className={`updateProfile`}
                          onClick={() => { toggles.setToggle(); setTaskData(item) }}
                          style={{ padding: "1px 10px" }}
                        >
                          Sign
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={taskCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </>
      </SplitPane>
      <BulkInvestigatorSignoff
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title={"Bulk Investigator Sign-off"}
        selectedIds={selectedIds}
        selectedSiteIds={selectedSiteIds}
        getSubjectPrincipleInvestigator={getSubjectPrincipleInvestigator}
        statsSubjectPrincipleInvestigator={statsSubjectPrincipleInvestigator}
        />
      <InvestigatorSignoff
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Investigator Sign-off"}
        taskData={taskData}
        getSubjectPrincipleInvestigator={getSubjectPrincipleInvestigator}
        statsSubjectPrincipleInvestigator={statsSubjectPrincipleInvestigator}
      />
    </>
  );
};

export default InvestigatorSignatureTableData;
